import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
  const planTabButton = document.querySelectorAll('.js-planTabButton');
  const planList = document.querySelectorAll('.js-planContentsItem');
  const planContentsWrapper = document.querySelector('.p-planContents__list');

  planTabButton.forEach((button) => {
    button.addEventListener('click', () => {
      planContentsWrapper.classList.add('is-animating');
      setTimeout(() => {
        planContentsWrapper.classList.remove('is-animating');
      }, 600); // アニメーションの duration に合わせる
      const selectedTime = button.getAttribute('data-time');

      planTabButton.forEach((btn) => btn.classList.remove('is-active'));
      button.classList.add('is-active');

      if(selectedTime === 'all') {
        planList.forEach((item) => {
          item.classList.add('is-active');
          item.style.opacity = 1
          item.style.transform = 'translateY(0)';
        });
        ScrollTrigger.refresh();
        return;
      }

      if(selectedTime === 'morning') {
        planList.forEach((item) => {
          if(item.getAttribute('data-time') === 'morning') {
            item.classList.add('is-active');
            item.style.opacity = 1
            item.style.transform = 'translateY(0)';
          } else {
            item.classList.remove('is-active');
          }
        });
        ScrollTrigger.refresh();
        return;
      }

      if(selectedTime === 'noon') {
        planList.forEach((item) => {
          if(item.getAttribute('data-time') === 'noon') {
            item.classList.add('is-active');
            item.style.opacity = 1
            item.style.transform = 'translateY(0)';
          } else {
            item.classList.remove('is-active');
          }
        });
        ScrollTrigger.refresh();
        return;
      }

      if(selectedTime === 'evening') {
        planList.forEach((item) => {
          if(item.getAttribute('data-time') === 'evening') {
            item.classList.add('is-active');
            item.style.opacity = 1
            item.style.transform = 'translateY(0)';
          } else {
            item.classList.remove('is-active');
          }
        });
        ScrollTrigger.refresh();
        return;
      }

      if(selectedTime === 'night') {
        planList.forEach((item) => {
          if(item.getAttribute('data-time') === 'night') {
            item.classList.add('is-active');
            item.style.opacity = 1
            item.style.transform = 'translateY(0)';
          } else {
            item.classList.remove('is-active');
          }
        });
        ScrollTrigger.refresh();
        return;
      }
    });
  });
};

export {
    init,
};
